import * as React from "react";

// import { useDemoData } from "@mui/x-data-grid-generator";
import { DataGrid } from "@mui/x-data-grid";

import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
} from "@mui/material";

//svg
import { ReactComponent as Add } from "../../resources/svg/Add.svg";
import { ReactComponent as Deleteb } from "../../resources/svg/buetrash.svg";

//png
import pp from "../../resources/images/background.png";
import {
  Delete,
  UploadFile as Upload,
  FileDownload as Download,
  Autorenew as Refresh,
} from "@mui/icons-material";
//scss
import BiddingPlayersStyle from "./biddingPlayers.module.scss";
import { ReactComponent as Edit } from "../../resources/svg/Group 79.svg";

//bootstrap
import { Container, Row, Col } from "react-bootstrap";

//component
import Deletefilemodal from "../../components/deletfilemodal/deletefilemodal";
import MouseOverPopover from "../../components/popover/popover";
import ResponsiveDrawer from "../../components/responsiveDrawer/responsiveDrawer";
import SelectLabels from "../../components/dropdowns/1/dropdown1";
import Cbtn from "../../components/commonbutton/cbtn";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Assignbundle from "../../components/assignbundlemodal/assignbundle";
import LoadingScreen from "../../components/loadingSpinner/loadingScreen";
import { useSelector } from "react-redux";
import { selectStatus } from "../../store/features/adminSlice";
import { useDispatch } from "react-redux";
import { Details } from "@mui/icons-material";
import SearchBar from "../../components/searchbar/searchbar";
import {
  deleteBiddingPlayer,
  fetchResetData,
  deleteAllPlayers,
  getBiddingPlayers,
  uploadBiddingPlayers,
  selectbiddingPlayersData,
} from "../../store/features/biddingPlayerSlice";
import biddingPlayerRoutes from "../../store/network routes/biddingPlayers";
import {
  NameCell,
  RolePill,
  YesNo,
  Muted,
} from "../../components/tableCells/tableCells";

export default function BiddingPlayers() {
  //react-router-dom hooks
  let navigate = useNavigate();
  let location = useLocation();

  //use Selector and useDispatch hooks
  let loadingStatus = useSelector(selectStatus);
  let dispatch = useDispatch();

  //useState hooks
  const [balanceLoader, setBalanceLoader] = React.useState([false]);
  const [loading, setLoading] = React.useState(true);
  const [query, setQuery] = React.useState("");
  const [error, setError] = React.useState("");
  const [deleteIds, setDeleteIds] = React.useState([]);
  const [showToast, setShowToast] = React.useState(true);
  const [open, setOpen] = React.useState(false);
  const [showDel, setShowDel] = React.useState(false);
  const [assignModel, setAssignModel] = React.useState({});
  const [uploading, setUploading] = React.useState(false);
  const [pendingUpload, setPendingUpload] = React.useState(null);
  const uploadInputRef = React.useRef(null);
  const [biddingPlayerRows, setBiddingPlayerRows] = React.useState([
    // {
    //   id: 1,
    //   profile: "",
    //   name: {
    //     name: ``,
    //     id: 1,
    //   },
    //   count: 1,
    //   nationality: "",
    //   role: "",
    //   battingHanded: "",
    //   bowlingHanded: "",
    //   marquee: {
    //     status: "No",
    //     id: 1,
    //   },
    //   elite: {
    //     status: "No",
    //     id: 1,
    //   },
    //   basePrice: "",
    //   delete: 1,
    // },
  ]);

  let getData = async () => {
    let res = await dispatch(getBiddingPlayers());
    setLoading(false);
    return res;
  };

  const handleDownloadTemplate = async (format) => {
    try {
      const blob = await biddingPlayerRoutes.downloadBiddingPlayersTemplate(
        format
      );

      // Auth failures come back as HTTP 200 with a JSON body, which would
      // otherwise be saved as a broken spreadsheet.
      if (blob.type && blob.type.includes("json")) {
        const { msg } = JSON.parse(await blob.text());
        alert(msg || "Could not download the format sheet. Retry.");
        return;
      }

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `bidding-players-format.${format}`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      alert("Could not download the format sheet. Retry.");
    }
  };

  // Picking a file no longer uploads it straight away. An upload used to add to
  // whatever was already in the pool, so importing a corrected sheet left every
  // player in it twice with no way to tell the copies apart. When the pool is
  // empty there is nothing to ask about and the sheet goes up as it always did.
  const handleUploadFile = (e) => {
    const file = e.target.files[0];
    // Reset immediately so picking the same file twice still fires onChange.
    e.target.value = "";
    if (!file) return;

    if (existingCount > 0) setPendingUpload(file);
    else runUpload(file, false);
  };

  const runUpload = async (file, replace) => {
    setPendingUpload(null);
    setUploading(true);
    let res;
    try {
      res = await dispatch(uploadBiddingPlayers({ file, replace }));
    } finally {
      setUploading(false);
    }

    const payload = res?.payload;
    if (payload?.statusCode === 200) {
      alert(payload.msg || "Players imported");
      window.location.reload();
      return;
    }

    let message = payload?.msg || "Upload failed! Retry";
    if (payload?.errors?.length) {
      message +=
        "\n\n" +
        payload.errors
          .slice(0, 10)
          .map(({ row, errors }) => `Row ${row}: ${errors.join(", ")}`)
          .join("\n");
      if (payload.errors.length > 10) {
        message += `\n...and ${payload.errors.length - 10} more row(s).`;
      }
    }
    alert(message);
  };

  let biddingPlayerDetails = useSelector(selectbiddingPlayersData);
  const existingCount = biddingPlayerDetails?.length || 0;

  React.useEffect(() => {
    getData();
  }, []);

  React.useEffect(() => {
    if (biddingPlayerDetails[0]) {
      let tempData = [...biddingPlayerDetails];
      let queryArr = query.toLowerCase().split(" ");
      queryArr.forEach((query) => {
        if (query) {
          tempData = tempData.filter(
            ({ name, role, battingHanded, bowlingHanded, nationality }) => {
              return (
                name?.toLowerCase()?.includes(query?.toLowerCase()) ||
                role?.toLowerCase()?.includes(query?.toLowerCase()) ||
                battingHanded?.toLowerCase()?.includes(query?.toLowerCase()) ||
                nationality?.toLowerCase()?.includes(query?.toLowerCase()) ||
                bowlingHanded?.toLowerCase()?.includes(query?.toLowerCase())
              );
            }
          );
        }
      });

      setBiddingPlayerRows(() =>
        tempData.map(
          (
            {
              image,
              name,
              marquee,
              _id,
              role,
              nationality,
              basePriceString,
              battingHanded,
              bowlingHanded,
              elite,
            },
            i
          ) => ({
            id: _id,
            _id,
            profile: image,
            name: {
              name: name?.split(" ")[1]
                ? `${name?.split(" ")[0][0]}. ${name?.split(" ")[1]}`
                : name,
              id: _id,
              image,
            },
            count: i + 1,
            nationality,
            role,
            battingHanded,
            bowlingHanded,
            marquee: {
              status: marquee ? "Yes" : "No",
              id: _id,
            },
            elite: {
              status: elite ? "Yes" : "No",
              id: _id,
            },
            delete: _id,
            basePrice: basePriceString,
            editDelete: {
              details: {
                image,
                marquee: {
                  status: marquee ? "Yes" : "No",
                  id: _id,
                },
                _id,
                role,
                nationality,
                basePriceString,
                battingHanded,
                bowlingHanded,
                elite: {
                  status: elite ? "Yes" : "No",
                  id: _id,
                },
              },
              show: false,
              setShow: (value) => {
                setBiddingPlayerRows((prev) => {
                  let temp = [...prev];
                  temp[i].editDelete.show = value;
                  return temp;
                });
              },
            },
          })
        )
      );
    }
  }, [biddingPlayerDetails, query]);

  const handleSearch = (e) => {
    setQuery(e.target.value);
  };

  //dispatch action from reducer

  //1. getBiddingPlayer

  // 2.deleteBiddingPlayer
  const deleteBiddingPlayerRow = async (id) => {
    // const res = await dispatch(deleteBiddingPlayers(id));
    // return res;
  };

  //useEffect hooks

  //1. location
  React.useEffect(() => {
    if (location.hash) {
      let elem = document.getElementById(location.hash.slice(1));
      if (elem) {
        elem.scrollIntoView({ behavior: "smooth" });
      }
    } else {
      window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    }
  }, [location]);

  //2. check whether the user is logged in or not
  React.useEffect(() => {
    if (loadingStatus === "error") {
      navigate("/login");
    }
  }, [loadingStatus]);

  //3.getBiddingPlayers called

  const columns = [
    // {
    //   field: "profile",
    //   headerName: "Profile",
    //   flex: 1,
    //   sortable: false,
    //   renderCell: (params) => {
    //     return (
    //       <div
    //         style={{
    //           background: `url(${params.value}) center center/cover`,
    //           width: "100%",
    //           height: "auto",
    //         }}
    //       />
    //     );
    //   },
    // },
    {
      field: "name",
      flex: 2,
      sortable: true,
      headerName: "Name",
      renderCell: (params) => {
        return (
          <NameCell
            name={params?.value?.name}
            image={params?.value?.image}
            action={
              <Link
                to={`/biddingPlayers/${params?.value.id}`}
                title="Edit player"
              >
                <Edit className={BiddingPlayersStyle.edit} />
              </Link>
            }
          />
        );
      },
      sortComparator: (v1, v2) => v1.name.localeCompare(v2.name),
    },
    {
      field: "nationality",
      headerName: "Nationality",
      flex: 1.5,
      sortable: true,
      renderCell: (params) => <Muted>{params.value}</Muted>,
      sortComparator: (v1, v2) =>
        v1.nameBiddingPlayer.localeCompare(v2.nameBiddingPlayer),
    },
    {
      field: "role",
      headerName: "Role",
      flex: 1.5,
      sortable: true,
      renderCell: (params) => <RolePill value={params.value} />,
      sortComparator: (v1, v2) => v1.localeCompare(v2),
    },
    {
      field: "elite",
      headerName: "Elite",
      flex: 1,
      renderCell: (params) => <YesNo value={params.value.status} tone="#363B64" />,
      sortComparator: (v1, v2) => v1.status.localeCompare(v2.status),
    },
    {
      field: "marquee",
      headerName: "Marquee",
      flex: 1,
      renderCell: (params) => <YesNo value={params.value.status} tone="#0040A8" />,
      sortComparator: (v1, v2) => v1.status.localeCompare(v2.status),
    },
    {
      field: "bowlingHanded",
      headerName: "Bowling",
      flex: 2,
      sortable: true,
      renderCell: (params) => <Muted>{params.value}</Muted>,
      sortComparator: (v1, v2) => v1.localeCompare(v2),
    },
    {
      field: "battingHanded",
      headerName: "Batting",
      flex: 2,
      sortable: true,
      renderCell: (params) => <Muted>{params.value}</Muted>,
      sortComparator: (v1, v2) => v1.localeCompare(v2),
    },
    {
      field: "delete",
      description: "This column has a value getter and is not sortable.",
      sortable: false,
      flex: 1,
      minWidth: 120,
      renderHeader: () => <></>,
      renderCell: (params) => {
        return (
          <button
            type="button"
            title="Delete player"
            className={BiddingPlayersStyle.rowDelete}
            onClick={async () => {
              await dispatch(deleteBiddingPlayer(params.value));
              window.location.reload();
            }}
          >
            <Deleteb />
          </button>
        );
      },
    },
    // {
    //   field: "Assign",
    //   headerName: "Assign",
    //   flex: 1,
    //   maxWidth: 90,
    //   sortable: false,
    //   renderCell: (params) => {
    //     return (
    //       <>
    //         <Cbtn
    //           onClick={() => {
    //             setAssignModel((prev) => ({
    //               ...prev,
    //               [params.value.id]: true,
    //             }));
    //           }}
    //           style={{
    //             backgroundColor: "transparent",
    //             width: "100% !important",
    //             // padding: "0.7rem 2.5rem",
    //             padding: "0",
    //             color: "#0040A8",
    //             fontFamily: "IBMPlexSans-SemiBold",
    //             // fontSize: "0.6rem",
    //             letterSpacing: "0px",
    //           }}
    //         >
    //           Assign Work
    //         </Cbtn>
    //         {assignModel[params.value.id] && (
    //           <Assignbundle
    //             biddingPlayerId={params.value.id}
    //             paymentAmount={params.value.balance}
    //             show={assignModel[params.value.id]}
    //             setShow={(value) => {
    //               setAssignModel((prev) => ({
    //                 ...prev,
    //                 [params.value.id]: value,
    //               }));
    //             }}
    //           ></Assignbundle>
    //         )}
    //       </>
    //     );
    //   },
    // },
    // {
    //   field: "Id",
    //   headerName: "Id",
    //   sortable: false,
    //   flex: 1,
    //   maxWidth: 80,
    //   renderCell: (params) => {
    //     return (
    //       <Cbtn
    //         onClick={() => {
    //           alert(`username is : ${params.value}`);
    //         }}
    //         style={{
    //           backgroundColor: "transparent",
    //           width: "100% !important",
    //           color: "#0040A8",
    //           fontFamily: "IBMPlexSans-SemiBold",
    //           fontSize: "0.9rem",
    //           letterSpacing: "0px",
    //         }}
    //       >
    //         View
    //       </Cbtn>
    //     );
    //   },
    // },
    // {
    //   field: "PostCount",
    //   headerName: "Post",
    //   sortable: true,
    //   flex: 1,
    //   maxWidth: 70,
    // },
    // {
    //   field: "balancepayable",
    //   headerName: "Balance Payable",
    //   sortable: false,
    //   flex: 1,
    //   minWidth: 180,
    //   renderCell: (params) => {
    //     return (
    //       <>
    //         <div>{params.value.balance}</div>
    //         {/* <Cbtn
    //           onClick={() => {
    //             setAssignModel((prev) => ({
    //               ...prev,
    //               [params.value.id]: true,
    //             }));
    //           }}
    //           style={{
    //             backgroundColor: "transparent",
    //             width: "100% !important",
    //             // padding: "0.7rem 2.5rem",
    //             color: "#0040A8",
    //             fontFamily: "IBMPlexSans-SemiBold",
    //             fontSize: "0.9rem",
    //             letterSpacing: "0px",
    //           }}
    //         >
    //           Assign Work
    //         </Cbtn> */}
    //         {balanceLoader[params.value.index] && (
    //           <CircularProgress
    //             sx={{ m: " 0 0.5rem", h: "0.7rem", w: "0.7rem" }}
    //           />
    //         )}
    //         <Cbtn
    //           onClick={async () => {
    //             setBalanceLoader((prev) =>
    //               prev.map((ele, i) =>
    //                 i === params.value.index ? true : false
    //               )
    //             );
    //             setBalanceLoader((prev) => prev.map((ele, i) => false));
    //           }}
    //           style={{
    //             backgroundColor: "transparent",
    //             width: "100% !important",
    //             color: "#0040A8",
    //             fontFamily: "IBMPlexSans-SemiBold",
    //             fontSize: "0.9rem",
    //             letterSpacing: "0px",
    //           }}
    //         >
    //           View
    //         </Cbtn>
    //         {/* {assignModel[params.value.id] && (
    //           <Assignbundle
    //             biddingPlayerId={params.value.id}
    //             paymentAmount={params.value.balance}
    //             show={assignModel[params.value.id]}
    //             setShow={(value) => {
    //               setAssignModel((prev) => ({
    //                 ...prev,
    //                 [params.value.id]: value,
    //               }));
    //             }}
    //           ></Assignbundle>
    //         )} */}
    //       </>
    //     );
    //   },
    // },
  ];

  return (
    <>
      {loadingStatus === "Loading" && <LoadingScreen />}
      {loadingStatus === "fulfilled" && (
        <ResponsiveDrawer>
          <Container>
            <div className={BiddingPlayersStyle.toolbar}>
              <div>
                <h1 className={BiddingPlayersStyle.mainHeading}>Players</h1>
                <div className={BiddingPlayersStyle.subHeading}>
                  {biddingPlayerRows?.length
                    ? `${biddingPlayerRows.length} players in the pool`
                    : "Manage the players going into the auction"}
                </div>
              </div>
              <div className={BiddingPlayersStyle.actions}>
                {/* One filled button per page. Everything else is a ghost, and
                    the two destructive actions sit past a divider so they are
                    not mistaken for part of the import flow. */}
                <Cbtn
                  to="/biddingPlayers/new"
                  className={BiddingPlayersStyle.btnPrimary}
                >
                  <Add className={BiddingPlayersStyle.add} />
                  Add Player
                </Cbtn>

                <input
                  type="file"
                  ref={uploadInputRef}
                  accept=".xlsx,.xls,.csv"
                  style={{ display: "none" }}
                  onChange={handleUploadFile}
                />
                <Cbtn
                  className={BiddingPlayersStyle.btnGhost}
                  disabled={uploading}
                  onClick={() => uploadInputRef.current?.click()}
                  title="Import players from a filled-in sheet"
                >
                  <Upload style={{ fontSize: "1rem", marginRight: "4px" }} />
                  {uploading ? "Uploading..." : "Upload sheet"}
                </Cbtn>

                <Cbtn
                  className={BiddingPlayersStyle.btnGhost}
                  onClick={() => handleDownloadTemplate("xlsx")}
                  title="Download the blank sheet to fill in"
                >
                  <Download style={{ fontSize: "1rem", marginRight: "4px" }} />
                  Template
                </Cbtn>

                <span className={BiddingPlayersStyle.btnDivider} />

                <Cbtn
                  className={BiddingPlayersStyle.btnDanger}
                  title="Refetch the player list, resetting teams and players"
                  onClick={async () => {
                    if (
                      await window.confirm(
                        "Reset the pool?\n\n" +
                          "Every player uploaded from a sheet is deleted, and " +
                          "the pool goes back to the catalogue players only.\n\n" +
                          "Every sale is undone, squads are emptied and purses " +
                          "go back to full."
                      )
                    ) {
                      let res = await dispatch(fetchResetData());
                      if (res.payload.statusCode === 201) {
                        alert("Data Resetted/Updated");
                        window.location.reload();
                      } else {
                        alert("Some Error Occured! Retry");
                      }
                    }
                  }}
                >
                  <Refresh style={{ fontSize: "1rem", marginRight: "4px" }} />
                  Fetch/Reset
                </Cbtn>

                <Cbtn
                  className={`${BiddingPlayersStyle.btnDanger} ${BiddingPlayersStyle.btnIcon}`}
                  title="Delete every player and the active auction"
                  onClick={async () => {
                    if (
                      await window.confirm(
                        "Are You Sure? This Will Delete Your Players and Active Auction!!"
                      )
                    ) {
                      let res = await dispatch(deleteAllPlayers());
                      if (res.payload.statusCode === 201) {
                        alert("All Players Deleted");
                        window.location.reload();
                      } else {
                        alert("Some Error Occured! Retry");
                      }
                    }
                  }}
                >
                  <Delete />
                </Cbtn>
              </div>
            </div>
            <Row className={BiddingPlayersStyle.searchRow}>
              <Col md={{ span: 4 }} style={{ marginTop: "22px" }}>
                <SearchBar
                  value={query}
                  onChange={handleSearch}
                  sx={{
                    borderRadius: "999px",
                  }}
                  searchSx={{
                    padding: "12px",
                  }}
                  searchColor="#b2acbd"
                  placeholder="Search Here... "
                />
              </Col>
            </Row>
            <Row
              style={{ padding: "22px 0 0", width: "100%", height: "33rem" }}
              className={`${BiddingPlayersStyle.table} ${BiddingPlayersStyle.gridWrap}`}
            >
              <DataGrid
                autoWidth
                autoHeight
                rowHeight={60}
                disableSelectionOnClick
                onSelectionModelChange={(ids) => {
                  setDeleteIds(ids);
                }}
                disableColumnFilter
                disableColumnMenu
                headerHeight={70}
                pageSize={20}
                rowsPerPageOptions={[20]}
                sx={{
                  maxHeight: "60vh",
                  borderRadius: "22px",
                  border: "none",
                  width: "calc(inherit - 100px)",
                  padding: 0,
                  // The grid now sits directly on the panel, so it drops its
                  // own card shadow and uses hairline rules between rows.
                  boxShadow: "none",

                  "& .MuiDataGrid-main": {
                    borderRadius: "22px",
                    maxHeight: "70vh",
                    overflowY: "overlay",
                  },
                  "& .MuiDataGrid-row": {
                    background: "#fff !important",
                    transition: "0.15s ease",
                  },
                  "& .MuiDataGrid-row:hover": {
                    background: "#fafbfd !important",
                  },
                  "& .MuiDataGrid-cell": {
                    borderBottom: "1px solid #eff0f6",
                  },
                  "& .MuiCheckbox-root": {
                    color: " #DBDBDB!important",
                  },
                  "& .MuiCheckbox-root.Mui-checked": {
                    color: "#0040A8 !important",
                  },
                  '& div[data-rowIndex][role="row"]': {
                    fontSize: 14,
                    fontFamily: "IBMPlexSans-Medium",
                    "& div": {
                      paddingTop: "2rem ",
                      paddingBottom: "2rem ",
                      fontFamily: "IBMPlexSans-Medium",
                    },
                  },
                  "& .MuiDataGrid-virtualScroller": {
                    overflow: "inherit",
                  },
                  "& 	.MuiDataGrid-cellCheckbox": {
                    width: "4rem !important",
                    maxWidth: "4rem !important",
                    minWidth: "4rem !important",
                    marginRight: "-15px !important",
                  },

                  "& .MuiDataGrid-columnHeaders": {
                    width: "100% !important",
                    borderBottom: "1px solid #eff0f6",
                    "& .MuiDataGrid-columnHeadersInner": {
                      backgroundColor: "transparent",

                      "& .MuiDataGrid-columnSeparator": {
                        display: "none",
                      },
                      // Column labels become small caps in the muted grey, so
                      // the player names are the only strong text in the grid.
                      "& .MuiDataGrid-columnHeaderTitle": {
                        fontFamily: "IBMPlexSans-SemiBold",
                        color: "#a098ae",
                        fontSize: "11px",
                        letterSpacing: "1.2px",
                        textTransform: "uppercase",
                      },
                    },
                  },
                  "& .MuiDataGrid-cellContent": {
                    fontFamily: "IBMPlexSans-Regular",
                    color: "#363B64",
                    background: "#fff",

                    // fontStyle: "1rem",
                  },
                  "& .MuiDataGrid-footerContainer": {
                    fontFamily: "IBMPlexSans-Medium",
                    borderRadius: "0px 0px 10px 10px",
                    background: "#fff !important",
                    minHeight: "35px",
                    "& .css-levciy-MuiTablePagination-displayedRows": {
                      margin: "1rem",
                    },
                  },
                  "& .MuiDataGrid-columnHeaderCheckbox, .css-1yoodjx-MuiDataGrid-root .MuiDataGrid-cellCheckbox":
                    {
                      width: "4rem !important",
                      maxWidth: "4rem !important",
                      minWidth: "4rem !important",
                      marginRight: "-15px !important",
                    },
                }}
                rows={biddingPlayerRows}
                columns={columns}
                loading={loading}
              />
              <Deletefilemodal
                ids={deleteIds}
                deleteFn={() => {}}
                show={showDel}
                setShow={setShowDel}
              />

              {/* Asked once the sheet is picked and only when the pool already
                  has players in it. Replacing is spelled out rather than named,
                  because it empties the squads and refunds the purses too. */}
              <Dialog
                open={Boolean(pendingUpload)}
                onClose={() => setPendingUpload(null)}
              >
                <DialogTitle>Replace the players already here?</DialogTitle>
                <DialogContent>
                  <DialogContentText>
                    The pool already holds {existingCount} player
                    {existingCount === 1 ? "" : "s"}. Adding this sheet on top
                    keeps them, which is what leaves the same player in the pool
                    twice.
                  </DialogContentText>
                  <DialogContentText style={{ marginTop: 12 }}>
                    Replacing clears the pool first, so the sheet is all that is
                    left. It also empties every squad and puts each purse back
                    to full, because those players will no longer exist.
                  </DialogContentText>
                </DialogContent>
                <DialogActions>
                  <Button onClick={() => setPendingUpload(null)}>Cancel</Button>
                  <Button onClick={() => runUpload(pendingUpload, false)}>
                    Add to pool
                  </Button>
                  <Button
                    color="error"
                    variant="contained"
                    onClick={() => runUpload(pendingUpload, true)}
                  >
                    Replace pool
                  </Button>
                </DialogActions>
              </Dialog>
            </Row>
          </Container>
        </ResponsiveDrawer>
      )}
    </>
  );
}
